// extracted by css-extract-rspack-plugin
export default {"linkImage":"_36f2dcb4"};